import { storage } from './storage';

const CACHE_KEY = 'cachedLocation';
const CACHE_TTL_MS = 2 * 60 * 1000;

export function getCachedLocation() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.latitude || !parsed?.longitude) return null;
    if (Date.now() - (parsed.cachedAt ?? 0) > CACHE_TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearLocationCache() {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    // ignore
  }
}

function cacheLocation(coords) {
  localStorage.setItem(
    CACHE_KEY,
    JSON.stringify({ ...coords, cachedAt: Date.now() }),
  );
}

export function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('geolocation_unavailable'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          address: `${pos.coords.latitude.toFixed(5)}, ${pos.coords.longitude.toFixed(5)}`,
        };
        cacheLocation(coords);
        resolve(coords);
      },
      reject,
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 },
    );
  });
}

export async function resolveStoredOrCurrentLocation({ forceRefresh = false } = {}) {
  if (!forceRefresh) {
    const cached = getCachedLocation();
    if (cached) return cached;
  } else {
    clearLocationCache();
  }

  try {
    const userRaw = await storage.getItem('user');
    if (userRaw) {
      const user = JSON.parse(userRaw);
      if (user.latitude && user.longitude) {
        const coords = {
          latitude: Number(user.latitude),
          longitude: Number(user.longitude),
          address: user.address ?? `${user.latitude}, ${user.longitude}`,
        };
        cacheLocation(coords);
        return coords;
      }
    }
  } catch {
    // continue
  }

  try {
    return await getCurrentPosition();
  } catch {
    return null;
  }
}

export async function pickLocation() {
  const coords = await getCurrentPosition();
  return coords;
}
